import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-direct-inquiry-tooltip',
  templateUrl: './direct-inquiry-tooltip.component.html',
})
export class BaseDirectInquiryTooltipComponent {
  @Input() profileName: string;
  @Input() branchName: string;
}
